import { render, staticRenderFns } from "./AddressLists.vue?vue&type=template&id=1a23c2a9&"
import script from "./AddressLists.vue?vue&type=script&lang=js&"
export * from "./AddressLists.vue?vue&type=script&lang=js&"
import style0 from "./AddressLists.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports